
/**
 * Obtenir un paramétrage applicatif si le code existe.
 * @param clef
 */
export const P = (clef: string) => {
    if (clef)
    {
        var valeur = (window['_P'] || {})[clef];
        if (valeur)
        {
            return valeur;
        }
        else
        {
            return null;
        }
    }
};

